import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { IExhibitor } from '../../../models/exhibitor.model.i';
import { ExhibitorService } from '../services/exhibitor.service';

// @ts-ignore
@Component({
    selector: 'app-exhibitor-overview',
    templateUrl: './exhibitor-overview.page.html',
    styleUrls: ['./exhibitor-overview.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'app-exhibitor-overview'
    },
    encapsulation: ViewEncapsulation.None
})

export class ExhibitorOverviewPage implements OnInit {

    exhibitors: IExhibitor[];

    constructor(public exhibitorService: ExhibitorService, private _router: Router) {
        this.exhibitors = exhibitorService.getAllExhibitors();
    }

    _queryTerm: string;

    get queryTerm(): string {
        return this._queryTerm;
    }

    set queryTerm(value: string) {
        this._queryTerm = value;
        this.exhibitors = this.exhibitorService.getAllExhibitors(value);
    }

    ngOnInit() {
    }

    onItemClicked(exhibitor: IExhibitor) {
        this.exhibitorService.setCurrentExhibitor(exhibitor);
        this._router.navigate(['/navigation'], {queryParams: {id: exhibitor.id}});
    }

    onClearSearch() {
        this.queryTerm = null;
    }

}


